export class CorrectionType {
  id: number;
  active: boolean;
  correctionCode: number;
  correctionCodeLabel: string;
}
